module.exports = __webpack_public_path__ + "media/images/athletes/1566-4e0d2ec31a8d5fe1654595542dda3219.png";